module.exports = __webpack_public_path__ + "static/media/HPP_Execution_Icon.2fb455a1.svg";